// extracted by mini-css-extract-plugin
export default {"root":"yrRbGRAU_H","menu":"n_j3QxRPyU","content":"OIjneH24JM"};